var map = {
	"./en/Breadcrumbs.json": "93bf",
	"./en/Common.json": "0a2d",
	"./en/Contacts.json": "bf1f",
	"./en/HeaderItems.json": "79ab",
	"./en/Main.json": "df29",
	"./en/PageNotFound.json": "3d8b",
	"./en/Validations.json": "3f19",
	"./ru/Breadcrumbs.json": "1ce2",
	"./ru/Common.json": "7dfa",
	"./ru/Contacts.json": "4c03",
	"./ru/HeaderItems.json": "7c0a",
	"./ru/Main.json": "051f",
	"./ru/PageNotFound.json": "ca56",
	"./ru/Validations.json": "64a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";